import {
  getPan,
  getPrice,
  isFunction,
  printMobileNum,
  printNationalCode,
  printNumber,
  printPan,
  printPrice,
} from "../helper";
import React from "react";

const TextInput = ({
  name,
  value,
  onChange,
  placeholder,
  autoFocus,
  className,
  type,
  readOnly,
  kind,
  maxLength,
  onKeyUp,
  tabIndex,
  onFocus,
}) => {
  const handleChange = (e) => {
    let value = e.target.value;

    if (isFunction(onChange)) {
      if (kind === "price") {
        const pr = getPrice(value);
        onChange(name, pr);
      } else if (kind === "number") {
        const num = getPrice(value);
        onChange(name, num);
      } else if (kind === "pan") {
        const pn = getPan(value);
        onChange(name, pn);
      } else if (kind === "percent") {
        if (value) {
          const percent = parseFloat(value);
          value = percent.toString();
          if (percent >= 0 && percent <= 100) onChange(name, value);
        } else {
          onChange(name, 0);
        }
      } else if (kind === "nationalCode") {
        let code = value;
        if (code.length > 10) code = code.slice(0, 10);
        onChange(name, printNationalCode(code));
      } else if (kind === "mobileNumber") {
        onChange(name, printMobileNum(value));
      } else onChange(name, value);
    }
  };

  const showWithSeperator = () => {
    if (!value) return "";
    if (!kind) return value;

    if (kind === "price") return printPrice(value);
    else if (kind === "number") return printPrice(value);
    else if (kind === "pan") return printPan(value);
    else if (kind === "nationalCode") return printNationalCode(value);
    else if (kind === "mobileNumber") return printMobileNum(value);
  };
  const getInputPattern = () => {
    if (!kind) return {};

    if (
      kind === "number" ||
      kind === "pan" ||
      kind === "nationalCode" ||
      kind === "mobileNumber"
    )
      return "[0-9]*";
  };
  const getInputMode = () => {
    if (!kind) return "text";

    if (
      kind === "number" ||
      kind === "pan" ||
      kind === "nationalCode" ||
      kind === "mobileNumber"
    )
      return "numeric";
  };
  return (
    <input
      tabIndex={tabIndex}
      onKeyUp={onKeyUp}
      maxLength={maxLength}
      pattern={getInputPattern()}
      inputMode={getInputMode()}
      dir="rtl"
      className={`textInput ${className}`}
      value={showWithSeperator()}
      autoFocus={autoFocus || false}
      placeholder={placeholder}
      onChange={handleChange}
      type={type || "text"}
      readOnly={readOnly || false}
      onFocus={onFocus}
    />
  );
};
export default TextInput;
